<template>
  <!-- 选电机 -->
  <Transition>
    <div v-show="CurrentPage === 1">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择电机:
      </div>

      <img
        style="
          width: 500px;
          height: 300px;
          color: white;
          margin: 0 auto;
          margin-top: 20px;
        "
        class="inner"
        src="Motor.png"
      />
      <el-row style="margin: 20px 200px">
        <el-col :span="5">
          <span style="margin-right: 10px">系列:</span>
          <el-select v-model="SelectedSerise" size="small">
            <el-option label="PEGASI" value="P"></el-option>
            <el-option label="VOLANS" value="V"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span style="margin-right: 10px; margin-left: 20px">波特率:</span>
          <el-select v-model="SelectedBaudRate" size="small">
            <el-option label="125k" value="125k"></el-option>
            <el-option label="250k" value="250k"></el-option>
          </el-select>
        </el-col>
      </el-row>

      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">电机型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">波特率</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Motors" :key="item">
        <div
          v-if="
            item.description.includes(SelectedBaudRate) &&
            item.model.startsWith(SelectedSerise)
          "
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.status }}</div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="BaudRateMatch(item.description)"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="MotorClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </Transition>
  <!-- 马达座 -->
  <transition>
    <div v-show="CurrentPage === 2">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择马达座:
      </div>
      <img
        class="inner"
        style="color: white; margin: 0 auto; margin-top: 20px"
        src="MotorSet.png"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">马达座型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">适配系列</div>
        <div style="line-height: 40px; height: 40px; width: 20%">描述</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div
        v-for="item in MotorSets"
        :key="item"
        style="
          background: hsl(0, 0%, 100%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 0px auto;
          padding: 8px 0;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.remark }}</div>
        <div
          style="line-height: 40px; height: 40px; width: 20%"
          v-html="item.status"
        ></div>
        <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
          <span style="cursor: pointer" @click.once="MotorSetClick(item)">选择</span>
        </div>
      </div>
    </div>
  </transition>
  <!-- 装饰盖 -->
  <transition>
    <div v-show="CurrentPage === 3">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择装饰盖:
      </div>
      <img
        style="color: white; height: 350px; margin: 0 auto; margin-top: 20px"
        src="Decorative cover.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">装饰盖型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">适配系列</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div
        v-for="item in Covers"
        :key="item"
        style="
          background: hsl(0, 0%, 100%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 0px auto;
          padding: 8px 0;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.remark }}</div>
        <div
          style="line-height: 40px; height: 40px; width: 20%"
          v-html="item.status"
        ></div>
        <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
          <span style="cursor: pointer" @click.once="CoverClick(item)">选择</span>
        </div>
      </div>
    </div>
  </transition>
  <!-- 牙盘 -->
  <transition>
    <div v-show="CurrentPage === 4">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择牙盘:
      </div>
      <img
        style="color: white; height: 300px; margin: 10px auto; margin-top: 20px"
        src="Chainwheel.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">牙盘型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">齿数</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div
        v-for="item in Chainwheels"
        :key="item"
        style="
          background: hsl(0, 0%, 100%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 0px auto;
          padding: 8px 0;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
        <div style="line-height: 40px; height: 40px; width: 30%">
          {{ matchTeeth(item) }}
        </div>
        <div
          style="line-height: 40px; height: 40px; width: 20%"
          v-html="item.status"
        ></div>
        <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
          <span style="cursor: pointer" @click.once="ChainwheelClick(item)">选择</span>
        </div>
      </div>
    </div>
  </transition>
  <!-- 垫圈 -->
  <transition>
    <div v-show="CurrentPage === 5">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择垫圈:
      </div>
      <img
        style="color: white; height: 200px; margin: 10px auto; margin-top: 20px"
        src="Washer.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">垫圈型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">备注</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div
        v-for="item in Washers"
        :key="item"
        style="
          background: hsl(0, 0%, 100%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 0px auto;
          padding: 8px 0;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.remark }}</div>
        <div
          style="line-height: 40px; height: 40px; width: 20%"
          v-html="item.status"
        ></div>
        <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
          <span style="cursor: pointer" @click.once="WasherClick(item)">选择</span>
        </div>
      </div>
    </div>
  </transition>
  <!-- 护盖 -->
  <transition>
    <div v-show="CurrentPage === 6">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择护盖:
      </div>
      <img
        style="color: white; height: 200px; margin: 10px auto; margin-top: 20px"
        src="Protecting cover.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">护盖型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">备注</div>
        <div style="line-height: 40px; height: 40px; width: 20%">Chain Line</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div
        v-for="item in ProtectingCovers"
        :key="item"
        style="
          background: hsl(0, 0%, 100%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 0px auto;
          padding: 8px 0;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
        <div style="line-height: 40px; height: 40px; width: 30%">{{ item.remark }}</div>
        <div style="line-height: 40px; height: 40px; width: 20%">
          {{
            item.description.match(/(\d\d)mm/i) == null
              ? "未知"
              : item.description.match(/(\d\d)mm/i)[1]
          }}
        </div>
        <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
          <span style="cursor: pointer" @click.once="ProtectingCoverClick(item)"
            >选择</span
          >
        </div>
      </div>
    </div>
  </transition>
  <!-- 码表 -->
  <transition>
    <div v-show="CurrentPage === 7">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择码表:
      </div>
      <img
        style="height: 300px; color: white; margin: 0 auto; margin-top: 20px"
        src="Screen.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">仪表型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">备注</div>
        <div style="line-height: 40px; height: 40px; width: 20%">波特率</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Meters" :key="item">
        <div
          v-if="item.description.includes(SelectedBaudRate)"
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.status }}</div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="BaudRateMatch2(item.description)"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="MeterClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <!-- 速度传感器 -->
  <transition>
    <div v-show="CurrentPage === 8">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择速度传感器:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">仪表型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">备注</div>
        <div style="line-height: 40px; height: 40px; width: 20%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in SpeedSensors" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.status }}</div>
          <div style="line-height: 40px; height: 40px; width: 20%">
            {{ matchLength(item) }}
          </div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="SpeedSensorClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- 电源线 -->
  <transition>
    <div v-show="CurrentPage === 9">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择电源线:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">线缆型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Cables" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
          v-if="item.description.includes('电源线')"
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">
            {{ matchLength(item) }}
          </div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="item.status"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="dyxClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- 码表线 -->
  <transition>
    <div v-show="CurrentPage === 10">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择码表线:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">线缆型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Cables" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
            border: solid 1px hsl(0, 0%, 95%);
          "
          v-if="item.description.includes('码表')"
        >
          <div
            style="
              line-height: 40px;
              width: 30%;
              display: flex;
              justify-content: center;
              align-self: center;
            "
          >
            {{ item.model }}
          </div>
          <div style="height: auto; width: 30%" v-html="item.description"></div>
          <div
            style="
              line-height: 40px;
              display: flex;
              justify-content: center;
              align-self: center;
              width: 20%;
            "
            v-html="item.status"
          ></div>
          <div
            style="
              line-height: 40px;
              display: flex;
              justify-content: center;
              align-self: center;
              width: 20%;
              color: cornflowerblue;
            "
          >
            <span style="cursor: pointer" @click.once="mbxClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- 灯线 -->
  <transition>
    <div v-show="CurrentPage === 11">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择灯线:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">线缆型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Cables" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
          v-if="item.description.includes('灯')"
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">
            {{ matchLength(item) }}
          </div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="item.status"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="dxClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- 指拨刹把 -->
  <transition>
    <div v-show="CurrentPage === 12">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择指拨刹把线:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">线缆型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Cables" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
          v-if="item.description.includes('刹把')"
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">
            {{ matchLength(item) }}
          </div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="item.status"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="zbsbClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- GearSensor -->
  <transition>
    <div v-show="CurrentPage === 13">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择GearSensor线:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">线缆型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Cables" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
          v-if="item.description.includes('sensor')"
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">
            {{ matchLength(item) }}
          </div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="item.status"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="gsClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- 二段线 -->
  <transition>
    <div v-show="CurrentPage === 14">
      <div
        style="
          font-size: 20px;
          color: #555555;
          text-align: left;
          margin: 40px auto 0 auto;
          width: 80%;
        "
      >
        请选择二段线:
      </div>
      <img
        style="height: 200px; color: white; margin: 0 auto; margin-top: 20px"
        src="Speed sensor.png"
        class="inner"
      />
      <div
        style="
          background: hsl(0, 0%, 95%);
          display: flex;
          flex-direction: row;
          width: 80%;
          margin: 10px auto 0 auto;
        "
      >
        <div style="line-height: 40px; height: 40px; width: 30%">线缆型号</div>
        <div style="line-height: 40px; height: 40px; width: 30%">线长</div>
        <div style="line-height: 40px; height: 40px; width: 20%">状态</div>
        <div style="line-height: 40px; height: 40px; width: 20%">操作</div>
      </div>
      <div v-for="item in Cables" :key="item">
        <div
          style="
            background: hsl(0, 0%, 100%);
            display: flex;
            flex-direction: row;
            width: 80%;
            margin: 0px auto;
            padding: 8px 0;
          "
        >
          <div style="line-height: 40px; height: 40px; width: 30%">{{ item.model }}</div>
          <div style="line-height: 40px; height: 40px; width: 30%">
            {{ matchLength(item) }}
          </div>
          <div
            style="line-height: 40px; height: 40px; width: 20%"
            v-html="item.status"
          ></div>
          <div style="line-height: 40px; height: 40px; width: 20%; color: cornflowerblue">
            <span style="cursor: pointer" @click.once="edxClick(item)">选择</span>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <transition>
    <div v-show="CurrentPage === 15">
      <div>
        <svg
          width="200px"
          height="200px"
          viewBox="0 0 96 96"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg"
          style="height: 200px; margin: 0 auto; margin-top: 100px"
        >
          <defs>
            <image
              width="192"
              height="192"
              xlink:href="data:image/png;base64,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"
              id="img_1"
            />
          </defs>
          <use
            xlink:href="#img_1"
            fill="#FFFFFF"
            stroke="none"
            transform="scale(0.5 0.5)"
          />
        </svg>
      </div>

      <el-button style="margin-top: 50px" type="primary" @click="getResultFile"
        >点击下载结果文件</el-button
      >
    </div>
  </transition>

  <div style="height: 100px"></div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { SearchProductPages, GetDocx } from "../common/httphelper";

let CableItem = function () {
  return {
    selected: false,
    obj: {},
  };
};

export default {
  data() {
    return {
      Motors: [],
      MotorSets: [],
      Covers: [],
      Chainwheels: [],
      Washers: [],
      ProtectingCovers: [],
      Meters: [],
      SpeedSensors: [],
      Cables: [],
      SelectedBaudRate: "125k",
      SelectedSerise: "V",
      SelectedMotor: {},
      SelectedMotorSet: {},
      SelectedCover: {},
      SelectedChainwheel: {},
      SelectedWasher: {},
      SelectedProtectingCover: {},
      SelectedMeter: {},
      SpeedSenderLength: {},
      SelectedSpeedSensor: {},
      SelectedCable: {
        power: CableItem(),
        meter: CableItem(),
        light: CableItem(),
        BrakeHandle: CableItem(),
        GearSensor: CableItem(),
        TwoSegmentLine: CableItem(),
      },
      CurrentPage: 1,
    };
  },
  methods: {
    newFormData() {
      return {
        model: "",
        catlog: "-1",
        status: "",
        more: {
          botelv: "全部",
          dengya: "全部",
          zhizaoshang: "全部",
          luosi: "全部",
          xiansu: "全部",
          chicun: "全部",
          xianjing: "全部",
          leibie: "全部",
          lianjieqi: "全部",
        },
      };
    },

    async loadMotors() {
      let body = this.newFormData();

      let [res1, res2] = await axios.all([
        SearchProductPages(24, 1, body, 10000),
        SearchProductPages(36, 1, body, 10000),
      ]);

      this.Motors = res1.data.data.concat(res2.data.data);
    },

    loadMotorSets() {
      let body = this.newFormData();
      SearchProductPages(37, 1, body, 10000).then((res) => {
        this.MotorSets = res.data.data;

        if (this.SelectedMotor.model.startsWith("V")) {
          this.MotorSets = this.MotorSets.filter(
            (item) => item.remark && item.remark.includes("VOLANS")
          );
        }

        if (this.SelectedMotor.model.startsWith("P")) {
          this.MotorSets = this.MotorSets.filter(
            (item) => item.remark && item.remark.includes("PEGASI")
          );
        }
      });

      scrollTo(0, 0);
    },

    async loadCovers() {
      let body = this.newFormData();

      let res = await SearchProductPages(26, 1, body, 10000);

      this.Covers = res.data.data.filter((item) => item.description.includes("cover"));

      scrollTo(0, 0);
    },

    async loadChainwheel() {
      let body = this.newFormData();

      let res = await SearchProductPages(31, 1, body, 10000);

      this.Chainwheels = res.data.data.filter((item) =>
        item.description.includes("Chainwheel")
      );

      scrollTo(0, 0);
    },

    async loadWasher() {
      let body = this.newFormData();

      let res = await SearchProductPages(31, 1, body, 10000);

      this.Washers = res.data.data.filter((item) => item.description.includes("Washer"));
    },

    async loadProtectingCover() {
      let body = this.newFormData();

      let res = await SearchProductPages(31, 1, body, 10000);

      this.ProtectingCovers = res.data.data.filter((item) =>
        item.description.includes("Lock Nut")
      );
    },

    async loadMeters() {
      let body = this.newFormData();

      let [res1, res2] = await axios.all([
        SearchProductPages(35, 1, body, 10000),
        SearchProductPages(38, 1, body, 10000),
      ]);

      this.Meters = res1.data.data.concat(res2.data.data);
    },

    async loadSpeedSensors() {
      let body = this.newFormData();

      let res = await SearchProductPages(41, 1, body, 10000);

      this.SpeedSensors = res.data.data;

      let that = this;

      this.SpeedSensors.sort((a, b) => {
        let av = that.matchLength(a);
        let bv = that.matchLength(b);

        if (av == "未知") av = 99999;
        if (bv == "未知") bv = 99999;

        return (
          Math.abs(av - that.SpeedSenderLength) - Math.abs(bv - that.SpeedSenderLength)
        );
      });
    },

    async loadCables() {
      let body = this.newFormData();

      let [res1, res2] = await axios.all([
        SearchProductPages(30, 1, body, 10000),
        SearchProductPages(32, 1, body, 10000),
      ]);

      this.Cables = res1.data.data.concat(res2.data.data);
    },

    MotorClick(item) {
      this.SelectedMotor = item;
      this.CurrentPage++;
      this.loadMotorSets();
    },

    MotorSetClick(item) {
      this.SelectedMotorSet = item;
      this.CurrentPage++;
      this.loadCovers();
    },

    CoverClick(item) {
      this.SelectedCover = item;
      this.CurrentPage++;
      this.loadChainwheel();
    },

    ChainwheelClick(item) {
      this.SelectedChainwheel = item;
      this.CurrentPage++;
      this.loadWasher();
    },

    async WasherClick(item) {
      this.SelectedWasher = item;

      await Swal.fire({
        icon: "question",
        cancelButtonText: "否",
        confirmButtonText: "是",
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick: false,
        title: "是否选择护盖？",
      }).then((res) => {
        if (res.value) this.CurrentPage++;
        else {
          this.CurrentPage = this.CurrentPage + 2;
          this.loadMeters();
        }
      });

      this.loadProtectingCover();
    },

    ProtectingCoverClick(item) {
      this.SelectedProtectingCover = item;
      this.CurrentPage++;
      this.loadMeters();
    },

    async MeterClick(item) {
      this.SelectedMeter = item;

      await Swal.fire({
        icon: "info",
        input: "text",
        title: "请输入速度传感器线缆长度\n\r（单位mm）",
        allowOutsideClick: false,
      }).then((value) => {
        this.SpeedSenderLength = value.value;
      });
      this.CurrentPage++;
      this.loadSpeedSensors();
    },

    async SpeedSensorClick(item) {
      let data = (await axios.get("checkboxs.txt")).data;

      const { value: formValues } = await Swal.fire({
        icon: "info",
        title: "请选择需要的线缆类型！",
        html: data,
        allowOutsideClick: false,
        confirmButtonText: "确定",
        focusConfirm: false,
        preConfirm: () => {
          return [
            document.getElementById("dyx").checked,
            document.getElementById("mbx").checked,
            document.getElementById("dx").checked,
            document.getElementById("zbsb").checked,
            document.getElementById("gs").checked,
            document.getElementById("edx").checked,
          ];
        },
      });

      if (formValues) {
        this.SelectedCable.power.selected = formValues[0];
        this.SelectedCable.meter.selected = formValues[1];
        this.SelectedCable.light.selected = formValues[2];
        this.SelectedCable.BrakeHandle.selected = formValues[3];
        this.SelectedCable.GearSensor.selected = formValues[4];
        this.SelectedCable.TwoSegmentLine.selected = formValues[5];
      }

      this.SelectedSpeedSensor = item;

      this.loadCables();
      this.CurrentPage++;
    },

    dyxClick(item) {
      this.SelectedCable.power.obj = item;
      this.CurrentPage++;
    },

    mbxClick(item) {
      this.SelectedCable.meter.obj = item;
      this.CurrentPage++;
    },

    dxClick(item) {
      this.SelectedCable.light.obj = item;
      this.CurrentPage++;
    },

    zbsbClick(item) {
      this.SelectedCable.BrakeHandle.obj = item;
      this.CurrentPage++;
    },

    gsClick(item) {
      this.SelectedCable.GearSensor.obj = item;
      this.CurrentPage++;
    },

    edxClick(item) {
      this.SelectedCable.TwoSegmentLine.obj = item;
      this.CurrentPage++;
    },

    BaudRateMatch(content) {
      let regex = /(r|R)ate(：|:).*((125|250).*bit)/;
      let matches = content.match(regex);
      if (matches) {
        return matches[3];
      }
      return "未知";
    },

    BaudRateMatch2(content) {
      let regex = /(B|b)aud(：|:).*((125|250).*bit)/;
      let matches = content.match(regex);
      if (matches) {
        return matches[3];
      }
      return "未知";
    },

    matchTeeth(item) {
      let res = item.description.match(/teeth: *(\d\d)/i);
      if (res) {
        return res[1];
      }
      return "未知";
    },

    matchLength(item) {
      var res = item.description.match(/length: *(\d*)mm/i);
      if (res) {
        return res[1];
      }
      return "未知";
    },

    getResultFile() {
      let updata = {
        NAME: sessionStorage.getItem("name").split("☆")[0],
        MotorModel: this.SelectedMotor.model ?? "-",
        MotorSetModel: this.SelectedMotorSet.model ?? "-",
        CoverModel: this.SelectedCover.model ?? "-",
        ToothDiscModel: this.SelectedChainwheel.model ?? "-",
        WasherModel: this.SelectedWasher.model ?? "-",
        ProtectingCoverModel: this.SelectedProtectingCover.model ?? "-",
        HMIModel: this.SelectedMeter.model ?? "-",
        SpeedSensorModel: this.SelectedSpeedSensor.model ?? "-",
        PowerCableModel: this.SelectedCable.power.obj.model ?? "-",
        HMICableModel: this.SelectedCable.meter.obj.model ?? "-",
        LightCableModel: this.SelectedCable.light.obj.model ?? "-",
        FingerBrakeHandleCable: this.SelectedCable.BrakeHandle.obj.model ?? "-",
        GearSensorCable: this.SelectedCable.GearSensor.obj.model ?? "-",
        BisectionCable: this.SelectedCable.TwoSegmentLine.obj.model ?? "-",
      };

      GetDocx(updata).then((res) => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "generated.docx";
        link.click();
      });
    },
  },
  mounted() {
    this.loadMotors();
  },
  watch: {
    CurrentPage: {
      handler(newVal, oldVal) {
        if (newVal === 9 && !this.SelectedCable.power.selected) this.CurrentPage++;
        if (newVal === 10 && !this.SelectedCable.meter.selected) this.CurrentPage++;
        if (newVal === 11 && !this.SelectedCable.light.selected) this.CurrentPage++;
        if (newVal === 12 && !this.SelectedCable.BrakeHandle.selected) this.CurrentPage++;
        if (newVal === 13 && !this.SelectedCable.GearSensor.selected) this.CurrentPage++;
        if (newVal === 14 && !this.SelectedCable.TwoSegmentLine.selected)
          this.CurrentPage++;
        if (newVal === 15) {
          // Swal.fire({
          //   text: JSON.stringify({
          //     电机: this.SelectedMotor.model,
          //     马达座: this.SelectedMotorSet.model,
          //     牙盘: this.SelectedChainwheel.model,
          //     马达座: this.SelectedCover,
          //     护盖: this.SelectedProtectingCover,
          //   }),
          // });
          //this.getResultFile();
        }
        scrollTo(0, 0);
      },
    },
  },
};
</script>

<style scoped>
/* we will explain what these classes do next! */
.v-enter-active {
  transition: all 1s ease-out;
  transition-delay: 0.6s;
}

.v-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.1, 1, 1);
  transition-delay: 0.5s;
}

.v-enter-from,
.v-leave-to {
  transform: translateX(50px);
  opacity: 0;
}

/* rules that target nested elements */
.v-enter-active .inner {
  transition: all 0.6s cubic-bezier(1, 0.1, 1, 1);
  transition-delay: 1s;
}

.v-leave-active .inner {
  transition: all 0.2s cubic-bezier(1, 0.1, 1, 1);
  transition-delay: 0.1s;
}

.v-enter-from .inner,
.v-leave-to .inner {
  transform: translateY(-30px);
  opacity: 0;
}

html,
body {
  scroll-behavior: smooth;
}
</style>
